
const ESC = 27

export { ESC }